import React from "react";

export default function Menu({ nse_cash }) {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">TYPE</div>
      <div className="menuExchange">MSG</div>
      <div className="menuExchange">COMMENT</div>
      {nse_cash === 1 ? <div className="menuExchange">INTEREST RATE</div> : null}
      <div className="menuExchange">DATE</div>
    </div>
  );
}
